import { hot } from "react-hot-loader";

import React from "react";
import ExpandableContent from "@streeteasy/design-system/legacy/ExpandableContent";
import { func, shape, string } from "prop-types";

import DateTimeSelector from "./DateTimeSelector";
import * as S from "./styled";
import TourTypeSection from "./TourTypeSection";

const RequestForm = ({ formValues, onChange }) => {
  const onMessageChange = event => onChange(event.target.value, event);

  return (
    <S.RequestFormDiv>
      <TourTypeSection onChange={onChange} tourType={formValues.tourType} />
      <DateTimeSelector datetimes={formValues.datetimes} onChange={onChange} />
      <S.AddAMessage>
        <ExpandableContent closedLabel="+ Add a message" openLabel="">
          <S.TextInput
            hint="optional"
            labelText="Message"
            name="message"
            onChange={onMessageChange}
            type="textarea"
            value={formValues.message}
          />
        </ExpandableContent>
      </S.AddAMessage>
    </S.RequestFormDiv>
  );
};

RequestForm.propTypes = {
  formValues: shape({
    preferredTourDate: string,
    timeOfDay: string,
    message: string
  }).isRequired,
  onChange: func.isRequired
};

export default hot(module)(RequestForm);
